import type { TreeModel, BBSymbolLink, StoryElementReference } from 'types/story';
import { componentWalk } from 'utils/blocks/component-walk';

type Predicate<T> = [key: string, value: any] | ((o: T) => boolean);

export function findComponentsBy<Result = TreeModel | BBSymbolLink>(
	collection: (TreeModel | BBSymbolLink | StoryElementReference)[],
	predicate: Predicate<TreeModel | BBSymbolLink>
) {
	const result: { component: Result; path: string }[] = [];

	if (Array.isArray(predicate)) {
		const [key, value] = predicate;
		componentWalk(collection, function walk({ component, path, index }) {
			if (component?.[key] === value) result.push({ component: component as unknown as Result, path });
			if ('children' in component) componentWalk(component.children, walk, path);
		});
	}

	if (typeof predicate === 'function') {
		componentWalk(collection, function walk({ component, path }) {
			if (predicate(component)) result.push({ component: component as unknown as Result, path });
			if ('children' in component) componentWalk(component.children, walk, path);
		});
	}

	return result;
}
